import { create, createStore } from 'zustand';
import type { PersistOptions } from 'zustand/middleware';
import { createJSONStorage, persist, subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import type { StateCreatorEnhance } from './type';

/**
 * @deprecated Use original zustand 'create' instead
 */
export function createEnhance<T>(
  creator: StateCreatorEnhance<T>,
  options?: {
    persist?: PersistOptions<T, unknown>;
  }
) {
  const { persist: persistOptions } = options || {};

  if (persistOptions) {
    return create<T>()(
      immer(
        subscribeWithSelector(
          persist(creator, {
            storage: createJSONStorage(() => localStorage),
            ...persistOptions,
          })
        )
      )
    );
  }

  return create<T>()(immer(subscribeWithSelector(creator as any)));
}

/**
 * @deprecated Use original zustand 'createStore' instead
 */
export function createStoreEnhance<T>(
  creator: StateCreatorEnhance<T>,
  options?: {
    persist?: PersistOptions<T, unknown>;
  }
) {
  const { persist: persistOptions } = options || {};

  if (persistOptions) {
    return createStore<T>()(
      immer(
        subscribeWithSelector(
          persist(creator, {
            storage: createJSONStorage(() => localStorage),
            ...persistOptions,
          })
        )
      )
    );
  }

  return createStore<T>()(immer(subscribeWithSelector(creator as any)));
}
